import { motion } from "framer-motion";

export const Chapter = ({ num, title, accent }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="mb-14"
  >
    <div className="flex items-center gap-4 mb-5">
      <span className="font-mono-tech text-sm text-[#0066FF] tracking-[0.25em]">{num}</span>
      <span className="h-px w-16 bg-[#0066FF]/50" />
      <span className="font-mono-tech text-xs uppercase tracking-[0.3em] text-slate-400">{accent}</span>
    </div>
    <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl">
      {title}
    </h2>
  </motion.div>
);
